import React from 'react';
import PropTypes from 'prop-types';
import { FilterSingle, Filter } from '@unite-us/app-components';
import { setFilterSearchPlaceholder, setAsyncSearch } from '../../../utils/filter';

const FilterBarItem = ({
  filter: f,
  asyncSearch,
  styles,
  onFiltersChange,
}) => {
  const {
    asyncSearch: filterAsyncSearch,
    searchPlaceholder,
  } = f;

  if (f.secondary) {
    return null;
  }

  return (
    f.single ? (
      <FilterSingle
        key={f.key}
        name={f.name}
        options={f.options}
        value={f.value}
        onFilterChange={(activeFilter) => onFiltersChange(f.key, activeFilter.value)}
      />
    ) : (
      <Filter
        hideSelectAll={f.hideSelectAll || false}
        key={f.key}
        name={f.name}
        pluralName={f.pluralName}
        options={f.options}
        onFiltersChange={(activeFilters, keySelected, callbacks) => {
          onFiltersChange(f.key, activeFilters, callbacks);
        }}
        searchPlaceholder={searchPlaceholder || setFilterSearchPlaceholder(f)}
        asyncSearch={filterAsyncSearch !== undefined ?
          setAsyncSearch(f, filterAsyncSearch) :
          setAsyncSearch(f, asyncSearch)}
        filterKey={f.key}
        uniqIdPrefix={f.key}
        styles={styles}
      />
    )
  );
};

FilterBarItem.propTypes = {
  filter: PropTypes.object.isRequired,
  asyncSearch: PropTypes.func,
  styles: PropTypes.object.isRequired,
  onFiltersChange: PropTypes.func.isRequired,
};

FilterBarItem.defaultProps = {
  asyncSearch: undefined,
};

export default FilterBarItem;
